module.exports = __webpack_public_path__ + "static/015_001-324c72c0eedcf44fb5d7e837054e1319.jpg";